const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
const COUNT_DURATION = 1500;

const GROUP_SEPARATOR_PATTERN = /\d([\u00A0\u202F\u2009 ])\d/;

function formatCount(value, separator) {
  const digits = Math.round(value).toString();

  if (!separator) {
    return digits;
  }

  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

function animateCount(el, target, finalText, separator) {
  const start = performance.now();
  let lastText = '';

  const tick = (now) => {
    const progress = Math.min((now - start) / COUNT_DURATION, 1);

    if (progress >= 1) {
      el.textContent = finalText;
      return;
    }

    const eased = 1 - Math.pow(1 - progress, 3);
    const text = formatCount(target * eased, separator);

    if (text !== lastText) {
      lastText = text;
      el.textContent = text;
    }

    requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
}

function initCounter(el, lockWidth) {
  const target = parseInt(el.dataset.countTo, 10);
  const finalText = el.dataset.countText || el.textContent;

  if (Number.isNaN(target)) {
    return;
  }

  const separatorMatch = finalText.match(GROUP_SEPARATOR_PATTERN);
  const separator = separatorMatch ? separatorMatch[1] : '';

  if (lockWidth) {
    el.style.minWidth = `${finalText.length}ch`;
  }

  el.textContent = formatCount(0, separator);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        observer.disconnect();
        animateCount(el, target, finalText, separator);
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(el);
}

export function initCounters(selector, { lockWidth = true } = {}) {
  if (window.matchMedia(REDUCED_MOTION_QUERY).matches) {
    return;
  }

  document
    .querySelectorAll(selector)
    .forEach((el) => initCounter(el, lockWidth));
}
